import { Label, Pivot, PivotItem, Separator } from "@fluentui/react";
import { connect } from "react-redux";
import { withRouter } from "../../../commons/component/withRouterCustom";
import { useEffect, useState } from "react";

// styles
import './ContractDetail.Styles.css';

// functions
import * as ComponentFunctions from './ContractDetails.Functions';

//i18Next
import { useTranslation, Trans } from 'react-i18next';

// components
import CommissionAgentAssociatedComponent from "../../../components/Contracts/CommissionAgentAssociated/CommissionAgentAssociated.Component";
import AddendumsComponent from "../../../components/Contracts/Addendums/Addendums.List/Addendums.Components";
import ProtocolParactitionersListComponent from "../../../components/Protocols/Practitioners/PractitionerList/ProtocolPractitiones.List.Component";
import StageListComponent from "../../../components/Contracts/Stages/StageList/StageList.Component";
import CycleListComponent from "../../../components/Contracts/Cycles/CycleList/CycleList.Component";
import ConceptListComponent from "../../../components/Contracts/Concept/ConceptList/ConceptList.Component";
import ConceptGroupedViewComponent from "../../../components/Contracts/Concept/ConceptGroupedView/ConceptGroupedView.Component";
// import BranchListComponent from "../../../components/Contracts/Branchs/BranchList/BranchList.Component";
import SettlementListComponent from "../../../components/Settlements/SettlementList/SettlementList.Component";
import ContractAssociationsComponent from "../../../components/Contracts/ContractAssociations/ContractAssociations.Component";
import { PageHeader } from "../../../commons/component/PageHeader/PageHeader";
import ContractHeaderComponent from "../../../components/Contracts/Header/ContractHeader.Component";
import ContractAccessListComponent from "../../../components/Contracts/Access/ContractAccess.List/ContractAccess.List.Component";
import FileUploadListComponent from "../../../components/Contracts/FileUpload/FileUploadList/FileUploadList.Component";
import ContractIAImportComponent from "../../../components/Contracts/ContractIAImport/Contract.IAImport.Component";

// models
import { ContractAddendum } from "../../../models/Entities/Contracts/ContractAddendum";
import BranchListComponent from "../../../components/Contracts/Branchs/BranchList/BranchList.Component";
import ContractNegotiationListComponent from "../../../components/ContractNegotiation/ContractNegotiationList/ContractNegotiationList.Component";
import { NegotiationConceptGridConnected } from "../../../components/ContractNegotiation";

const ContractDetailPage = (props: ComponentFunctions.Props) => {

    // state
    const [SelectedAddendum, setSelectedAddendum] = useState<ContractAddendum | undefined>(undefined);
    const [selectedNegotiationId, setSelectedNegotiationId] = useState<string | undefined>(undefined);

    //useTranslation()
    const [t] = useTranslation();

    useEffect(() => {
        props.GetContractById(props.ContractId);
        if (props.Contract) {
            props.GetContractAddendumsByContractId(props.ContractId);
        }
    }, [props.ContractId]);

    // useEffect(() => {
    //     if (props.DefaultContractAddendum) {
    //         setSelectedAddendum(props.DefaultContractAddendum);
    //     }
    // }, [props.DefaultContractAddendum]);

    // useEffect(() => {
    //     if(SelectedAddendum) {
    //         props.GetAllContractsConcept(props.ContractId);
    //         props.GetAllContractCommissionConcepts(props.ContractId);
    //         props.GetAllContractsStage(props.ContractId, SelectedAddendum!.id);
    //     }
    // }, [SelectedAddendum]);

    return (
        <>
            <PageHeader title={t('contractDetailPage.contractDetailtitle')} />
            <ContractHeaderComponent ContractId={props.ContractId} />
            <div className="Section">
                <AddendumsComponent ContractId={props.ContractId} OnAddendumSelected={setSelectedAddendum} />
            </div>
            <div className="ContractPageContent">
                <div className="Section">
                    {SelectedAddendum?.contractAddendumType !== 1 &&
                        <Pivot>
                            <PivotItem headerText={t('contractDetailPage.contractDetailVisits')}>
                                <div className="VisitasSection">
                                    <div>
                                        {SelectedAddendum && <StageListComponent ContractId={props.ContractId} ContractAddendumId={SelectedAddendum?.id} />}
                                    </div>
                                    <div>
                                        <Label>{t('contractDetailPage.contractDetailCycles')}</Label>
                                        {SelectedAddendum && <CycleListComponent ContractId={props.ContractId} ContractAddendumId={SelectedAddendum?.id} />}
                                        <Separator />
                                        <Label>{t('contractDetailPage.contractDetailBranchs')}</Label>
                                        {SelectedAddendum && <BranchListComponent ContractId={props.ContractId} ContractAddendumId={SelectedAddendum.id} />}
                                    </div>
                                </div>
                            </PivotItem>
                            <PivotItem headerText={t('contractDetailPage.contractDetailItem.conceptsSettled')}>
                                {SelectedAddendum && (
                                    <Pivot className='ConceptsViewSubPivot'>
                                        <PivotItem headerText='Lista'>
                                            <ConceptListComponent
                                                ContractId={props.ContractId}
                                                ContractAddendumId={SelectedAddendum?.id}
                                            />
                                        </PivotItem>
                                        <PivotItem
                                            headerText='Vista alternativa'
                                            onRenderItemLink={() => (
                                                <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
                                                    Vista alternativa
                                                    <span style={{
                                                        fontSize: '0.6rem',
                                                        fontWeight: 700,
                                                        lineHeight: 1,
                                                        padding: '2px 6px',
                                                        borderRadius: 999,
                                                        background: '#fef3c7',
                                                        color: '#92400e',
                                                        border: '1px solid #fcd34d',
                                                        textTransform: 'uppercase',
                                                        letterSpacing: '0.04em',
                                                        verticalAlign: 'middle',
                                                    }}>
                                                        Preview
                                                    </span>
                                                </span>
                                            )}
                                        >
                                            <ConceptGroupedViewComponent
                                                ContractId={props.ContractId}
                                                ContractAddendumId={SelectedAddendum?.id}
                                            />
                                        </PivotItem>
                                    </Pivot>
                                )}
                            </PivotItem>
                            <PivotItem headerText={t('contractDetailPage.contractDetailItem.liquidations')}>
                                <SettlementListComponent ContractId={props.ContractId} />
                            </PivotItem>
                            {props.Protocol && props.Contract && <PivotItem headerText={t('contractDetailPage.contractDetailItem.medicalEquipment')}>
                                <>
                                    {/* <h5>{t('contractDetailPage.contractDetailFeeDivision')}</h5> */}
                                    {/* <FeeDivisionContractComponent ContractId={props.Contract.id} /> */}
                                    {/* <Separator /> */}
                                    <ProtocolParactitionersListComponent showParticipation={(props.feeDivision || 0) === 0} ContractId={props.ContractId} ProtocolId={props.Protocol?.id} />
                                    {/* <Pivot>
                                    <PivotItem headerText={t('contractDetailPage.contractDetailItem.financialParticipation')}>
                                        <ProtocolConceptMultiSelectorComponent
                                            concepts={props.ContractConcepts}
                                            selectedConceptIds={props.ContractCommissionConcepts?.map((contractCommissionConcept) => contractCommissionConcept.conceptId) || []}
                                            showPercentage={true}
                                            onAddConcept={AddConcept}
                                            onDeleteConcept={DeleteConcept}
                                        //onChangeParticipationPercentage={ChangeParticipationPercentage}
                                        //onCostParticipationActiveChange={ChangeCostParticipationActive}
                                        //onCostParticipationPercentageChange={ChangeCostParticipationPercentage}
                                        />
                                    </PivotItem>
                                    <PivotItem headerText={t('contractDetailPage.contractDetailItem.teamMembers')}>
                                       
                                    </PivotItem>
                                </Pivot> */}
                                </>
                            </PivotItem>}
                        </Pivot>
                    }
                    {SelectedAddendum?.contractAddendumType === 1 &&
                        <>
                            <ContractNegotiationListComponent
                                contractAddendumId={SelectedAddendum.id}
                                contractId={props.ContractId}
                                onNegotiationSelected={setSelectedNegotiationId}
                            />
                            {selectedNegotiationId && (
                                <>
                                    <Separator />
                                    <NegotiationConceptGridConnected
                                        contractId={props.ContractId}
                                        contractNegotiationId={selectedNegotiationId}
                                    />
                                </>
                            )}
                        </>
                    }

                </div>
                <div className="Section">

                    {props.ContractId && <FileUploadListComponent
                        ContractId={props.ContractId}
                        entityType="contract"
                        viewMode="list"
                    />}
                    <Separator />
                    <ContractIAImportComponent contractId={props.ContractId} />
                    <Separator />

                    {props.Contract && <ContractAccessListComponent ContractId={props.ContractId} />}
                    <Separator />
                    <ContractAssociationsComponent ContractId={props.ContractId} />
                    <CommissionAgentAssociatedComponent ContractId={props.ContractId} />
                </div>
            </div>

        </>);
}

export default withRouter(connect(
    ComponentFunctions.mapStateToProps,
    ComponentFunctions.mapDispatchToProps
)(ContractDetailPage as any));